import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 55,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 16
  },
  titleh1: {
    fontWeight: 'bold',
    fontSize: 26,
    marginBottom: 24
  },
  title: {
    fontWeight: 'bold',
    fontSize: 18,
  },
  body: {
    fontSize: 16,
    width: '680px',
    height: '76px',
    marginBottom: 46
  },
  historyContainer: {
    marginTop: 40
  },
  historyTitle: {
    marginBottom: 16
  },
  historyBody: {
    fontSize: 16,
    fontFamily: 'Roboto',
    lineHeight: '24px',
    width: '699px',
    height: '96px',
    marginBottom: 24
  },
  tableHeaderCell: {
    fontSize: '16px',
    fontWeight: 700,
    fontFamily: 'Roboto',
    borderBottom: '2px solid rgba(0, 0, 0, 0.12)',
    paddingLeft: 0,
    paddingRight: '8px',
    paddingBottom: '16px'
  },
  tableHeaderCellWithPadding: {
    fontSize: '16px',
    fontWeight: 700,
    fontFamily: 'Roboto',
    borderBottom: '2px solid rgba(0, 0, 0, 0.12)',
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingBottom: '16px'
  },
  tableDataCell: {
    fontSize: '16px',
    fontWeight: 400,
    fontFamily: 'Roboto',
    paddingLeft: 0,
    paddingRight: '8px',
    paddingTop: '4px',
    paddingBottom: '4px',
    borderBottom: 'none'
  },
  tableDataCellWithPadding: {
    fontSize: '16px',
    fontWeight: 400,
    fontFamily: 'Roboto',
    padding: '6px 8px 6px 8px',
    borderBottom: 'none'
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: 28,
    gap: 8,
    marginRight: 400
  },
  pageNumberBox: {
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    fontFamily: 'Roboto'
  }
}));
